export default [
  {
    path: '/membresias',
    name: 'membership',
    component: () => import('@/views/memberships/Membership.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/configuraciones/membresias',
    name: 'membershipPlansSettings',
    component: () => import('@/views/memberships/MembershipPlansSettings.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/membresias/solicitudes',
    name: 'membershipRequests',
    component: () => import('@/views/memberships/MembershipRequests.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
